import React from 'react';

export type AnchorInNewWindowProps = {
  children: React.ReactNode;
};

export const AnchorInNewWindow: React.FC<AnchorInNewWindowProps> = ({ children, ...props }) => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);
